import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { returnCCImage } from '../../utils/cc-images';
export var PaymentIconsAndDigits = function (_a) {
    var _b = _a.payments, payments = _b === void 0 ? [] : _b, _c = _a.paymentMethods, paymentMethods = _c === void 0 ? [] : _c;
    var filteredPaymentMethods = paymentMethods.length > 0
        ? paymentMethods.filter(function (item, index, self) {
            return index ===
                self.findIndex(function (item2) {
                    return item2.lastFour === item.lastFour &&
                        item2.cardType === item.cardType;
                });
        })
        : payments.filter(function (item, index, self) {
            return index ===
                self.findIndex(function (item2) { return item2.value === item.value && item2.type === item.type; });
        });
    return (React.createElement("div", { className: "sui-flex sui-ml-2 sui-w-full sui-flex-wrap" }, (function () {
        if ((filteredPaymentMethods === null || filteredPaymentMethods === void 0 ? void 0 : filteredPaymentMethods.length) > 0) {
            return filteredPaymentMethods === null || filteredPaymentMethods === void 0 ? void 0 : filteredPaymentMethods.map(function (payment, index) { return (React.createElement("div", { key: index, className: "sui-flex sui-my-[2px] sui-mr-[8px] sui-max-h-[28px] sui-text-base" },
                returnCCImage((payment === null || payment === void 0 ? void 0 : payment.entryMode) !== 'APPLE_PAY'
                    ? payment.cardType ||
                        payment.type
                    : 'APPLE', 28, 43.68),
                "\u00A0 -\u00A0",
                (payment === null || payment === void 0 ? void 0 : payment.lastFour) ||
                    ((payment === null || payment === void 0 ? void 0 : payment.value) && (React.createElement(Typography, { variant: "body-base", key: index },
                        (payment === null || payment === void 0 ? void 0 : payment.entryMode) !== 'APPLE_PAY' &&
                            "".concat((payment === null || payment === void 0 ? void 0 : payment.lastFour) ||
                                (payment === null || payment === void 0 ? void 0 : payment.value)),
                        index !== (filteredPaymentMethods === null || filteredPaymentMethods === void 0 ? void 0 : filteredPaymentMethods.length) - 1 && ', '))))); });
        }
        return null;
    })()));
};
